const emitRestoreRequest = ({ socket, userId, actorId, mergeDuplicate }) => new Promise(resolve => {
    socket.emit('.restore_user', {
        id: userId,
        _actorId: actorId,
        mergeDuplicate,
    }, resolve);
});

export const requestDeletedUserRestore = async ({
    socket,
    user,
    actorId,
    confirmMerge = message => window.confirm(message),
    notifyError = message => window.alert(message),
}) => {
    let response = await emitRestoreRequest({
        socket,
        userId: user.id,
        actorId,
        mergeDuplicate: false,
    });

    if (!response?.success && response?.canMerge) {
        const shouldMerge = confirmMerge(
            `${response.error}\n\nVols fusionar-lo amb el casteller de la paperera? `
            + 'Es conservaran l\'historial, les assistències i les posicions de pinya.'
        );

        if (!shouldMerge) return false;

        response = await emitRestoreRequest({
            socket,
            userId: user.id,
            actorId,
            mergeDuplicate: true,
        });
    }

    if (!response?.success) {
        notifyError(response?.error || 'No s\'ha pogut restaurar el casteller.');
        return false;
    }

    socket.emit('.request_users');
    socket.emit('.request_deleted_users');
    return true;
};
